// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 2,
        parentComponent: true,
        card: {
            type: 'Form'
        },
        hideButtons: ['Delete'],
        actions: {
            listAction: "/api/MEIndicator/GetIndicatorDetail/",
            deleteAction: "/api/MEIndicator",
            updateAction: "/api/MEIndicator",
            createAction: "/api/MEIndicator"
        },
        fields: {
            ME_IndicatorId: {
                primaryKey: true,
            },
            Code: {
                type: "TextInput",
                title: "Code" 
            },
            Description: {
                title: "Indicator Name",
                type: "TextInput",
                required: true,
                languageManager: true,
                tableName: "ME_Indicator",
            },
            Order: {
                required: true,
                type: "TextInput",
                title: "Order" 
            },            
            ProgramId: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                title: "Program"
            },
            Type: {
                required: true,
                type: "Hidden",
                autocomplete: true,
                title: "Type"
            },
            FrequencyId: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                title: "Frequency"
            },
            PermissionId: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                title: "Permission"
            },
            HasLevel: {
                list: false,
                autocomplete: true,
                type: "ComboBox",
                title: "Has reporting level"
            },
            ReportAll: {
                list: false,
                autocomplete: true,
                type: "ComboBox",
                title: "Must report all indicators"
            },
            Unit: {
                type: "Hidden",
                chips: true,
                title: "Unit of measure"
            },
            Periodicity: {
                type: "Hidden",
                autocomplete: true,
                title: "Frequency"
            },
            MeasurementType: {
                required: true,
                type: "Hidden",
                autocomplete: true,
                title: "Measurement Type"
            },
            Source: {
                required: true,
                type: "Hidden",
                autocomplete: true,
                title: "Source"
            },
            CollectionMethod: {
                required: true,
                type: "Hidden",
                autocomplete: true,
                title: "Collection Method"
            },
            CollectionAgent: {
                required: true,
                type: "Hidden",
                autocomplete: true,
                title: "Collection Agent"
            },
            DifficultyToCollect: {
                required: true,
                type: "Hidden",
                autocomplete: true,
                title: "Difficulty To Collect"
            },
            ReportedBy: {
                required: true,
                type: "Hidden",
                autocomplete: true,
                title: "Reported By"
            },
            UsedBy: {
                required: true,
                type: "Hidden",
                autocomplete: true,
                title: "Used By"
            },
            IsSystem: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                title: "Standard Indicator"
            },
            Active: {
                required: true,
                list: false,
                autocomplete: true,
                type: "ComboBox",
                title: "Active"
            },
            Information: {
                title: "Information",
                type: "TextInput",
                languageManager: true,
                tableName: "ME_Indicator",
            }
        },
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) { },

        //#. fn_formCancel function
        formCancel(state, payload) { },

        //#. fn_recordCreated function
        recordCreated(state, payload) { },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) { },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) { },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) { },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) { }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        }
    }
}